import { addPermissionsToRoute } from '@qsrsoft/myq-core';
import { mtOnlyMenuFilters } from '../mtEnterprises';

const routes = {
  name: 'People',
  icon: 'mdi-account-multiple-outline',
  path: '/reports/people',
  // MT-only: People has no MULTICLIENT_ORGS equivalent, so this group stays
  // narrower than the other sections' `multiClientMenuFilters`.
  menuFilters: mtOnlyMenuFilters,
  ...addPermissionsToRoute(['mtPeople']),
  children: [
    {
      path: '/reports/people/employeeRoster',
      name: 'Employee Roster',
      meta: { id: 'reports-mtPeopleEmployeeRoster' },
      component: () => import('./EmployeeRoster.vue'),
    },
    {
      path: '/reports/people/birthdaysAnniversaries',
      name: 'Birthdays & Anniversaries',
      meta: {
        id: 'reports-mtPeopleBirthdaysAnniversaries',
      },
      component: () =>
        import('./birthdayAnniversary/BirthdaysAnniversaries.vue'),
    },
    {
      path: '/reports/people/overTimeAudit',
      name: 'Overtime Audit',
      meta: { id: 'reports-mtPeopleOvertimeAudit' },
      component: () => import('./OvertimeAudit.vue'),
    },
    {
      path: '/reports/people/employeeLookBack',
      name: 'Emp Hours Look Back',
      meta: { id: 'reports-mtPeopleEmpHoursLookBack' },
      component: () => import('./EmployeeHoursLookBack.vue'),
    },
    {
      path: '/reports/people/employeePunches',
      name: 'Employee Punches',
      meta: { id: 'reports-mtPeopleEmployeePunches' },
      component: () => import('./EmployeePunches.vue'),
    },
    {
      path: '/reports/people/timeAttendance',
      name: 'Time and Attendance',
      meta: { id: 'reports-mtPeopleTimeAndAttendance' },
      component: () => import('./TimeAndAttendance.vue'),
    },
    {
      path: '/reports/people/payrollLedger',
      name: 'Payroll Ledger',
      meta: { id: 'reports-mtPeoplePayrollLedger' },
      component: () => import('./PayrollLedger.vue'),
    },
  ],
};

export default routes;
